import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import SearchAccount from './SearchAccount'

interface SearchAccountModalProps extends BaseModalProps {}

export const SearchAccountModal: React.FunctionComponent<SearchAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <SearchAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
